<template>
  <div class="team-member pt-3 pb-3">
    <a class="team-member-header d-flex align-items-center" @click="click">
      <div class="team-member-avatar text-center ml-2 mr-2">
        <avatar :src="member.photo" size="1.875rem" />
      </div>
      <div class="d-flex flex-grow-1">
        <div class="flex-grow-1 align-self-center">
          <div class="team-member-name">{{ name }}</div>
          <div class="team-member-status">
            <template v-if="member.isManager">Lead</template>
            <template v-else-if="member.justJoined">Just joined</template>
          </div>
        </div>
        <div v-if="member.showBirthdayIcon" class="team-member-icon">
          <birthday-cake-icon />
        </div>
      </div>
    </a>
    <b-collapse ref="actions">
      <div class="d-flex mt-3">
        <div class="member-qm-line" />
        <div class="member-qm">
          <b-link v-if="!isMe" @click="$emit('give-kudo', member)"><kudos-icon /> Give kudo</b-link>
          <b-link v-if="!isMe" @click="$emit('send-message', member)"><chat-icon /> Send message</b-link>
          <b-link :to="{name: 'UserProfile', params: { userId: member.id }}"><avatar-icon /> View Profile</b-link>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import Avatar from '@/components/common/Avatar'
import KudosIcon from '@/assets/images/kudos.svg'
import AvatarIcon from '@/assets/images/avatar.svg'
import ChatIcon from '@/assets/images/chat.svg'
import BirthdayCakeIcon from '@/assets/images/birthday-cake.svg'
import { userName } from '@/helpers/helpers'

export default {
  name: 'TeamMember',

  props: {
    member: {
      type: Object,
      required: true
    },

    meProfile: {
      type: Number
    }
  },

  computed: {
    name() {
      return userName(this.member)
    },

    isMe() {
      return this.member.id === this.meProfile
    }
  },

  methods: {
    click() {
      this.$refs.actions.toggle()
    }
  },

  components: {
    Avatar,
    KudosIcon,
    AvatarIcon,
    ChatIcon,
    BirthdayCakeIcon
  }
}
</script>
